import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { selectToken } from '../../../util/tokenSelector.js';
import { Input } from '../Input/Input.js';
import { useExperimentContext } from '../../../contexts/session/Experiment.js';
import { useThemeContext } from '../../../contexts/session/Theme.js';
import { RadioButtonStyled } from './RadioButton.styled.js';

var _excluded = ["state", "selection", "children"];
var getRadioButtonColorTokens = function getRadioButtonColorTokens(_ref) {
  var disabled = _ref.disabled,
    checked = _ref.checked,
    radioCheckboxA11yContrastFix = _ref.radioCheckboxA11yContrastFix;
  if (disabled) {
    return {
      radioButtonBorderColorToken: radioCheckboxA11yContrastFix ? 'state.disabled' : 'base.subtle',
      radioButtonColorToken: radioCheckboxA11yContrastFix ? 'state.disabled' : 'deprecated.neutral.disabled-2'
    };
  }
  if (checked) {
    return {
      radioButtonBorderColorToken: radioCheckboxA11yContrastFix ? 'state.active' : 'product.primary.strong',
      radioButtonColorToken: radioCheckboxA11yContrastFix ? 'state.active' : 'product.primary'
    };
  }
  return {
    radioButtonBorderColorToken: radioCheckboxA11yContrastFix ? 'state.inactive' : 'base.default',
    radioButtonColorToken: 'base.surface.floating.inverted'
  };
};

/**
 * RadioButtons allow users to select a single option from a set of multiple options. Unlike Toggles, this component allow the user to choose from 2 or more options, and require the user to submit/save for the actions to take effect.
 */
var RadioButton = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var state = _ref2.state,
    selection = _ref2.selection,
    children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var theme = useThemeContext();
  var _useExperimentContext = useExperimentContext(),
    radioCheckboxA11yContrastFix = _useExperimentContext.radioCheckboxA11yContrastFix;
  var disabled = state === 'disabled';
  var checked = selection === 'selected';
  var _getRadioButtonColorT = getRadioButtonColorTokens({
      disabled: disabled,
      checked: checked,
      radioCheckboxA11yContrastFix: radioCheckboxA11yContrastFix
    }),
    radioButtonBorderColorToken = _getRadioButtonColorT.radioButtonBorderColorToken,
    radioButtonColorToken = _getRadioButtonColorT.radioButtonColorToken;
  var radioButtonColor = selectToken(theme.background, radioButtonColorToken);
  var radioButton = /*#__PURE__*/React.createElement(RadioButtonStyled, {
    borderStyle: "solid",
    borderRadius: "max",
    borderColor: radioButtonBorderColorToken,
    borderWidth: "2",
    $checked: checked,
    $color: radioButtonColor
  });
  var typography = selectToken(theme.typography, 'body-s');
  var marginTop = typography ? "calc((".concat(typography.lineHeight, " - ").concat(typography.fontSize, ") / 2)") : '2px';
  return /*#__PURE__*/React.createElement(Input, _extends({
    inputType: "radio",
    selection: selection,
    state: state,
    control: {
      component: radioButton,
      styled: RadioButtonStyled,
      size: '20px'
    }
  }, rest, {
    ref: ref
  }), children &&
  /*#__PURE__*/
  // TODO: ADSWEB-1082 Hardcoded div to add margin to the label children, should not be needed when align to 2.0.1
  React.createElement("div", {
    style: {
      marginTop: marginTop,
      display: 'flex',
      flexDirection: 'row'
    }
  }, children));
});
RadioButton.displayName = 'RadioButton';

export { RadioButton };
//# sourceMappingURL=RadioButton.js.map
